import React from "react";
import { Select } from "antd";

import {
  getSearchableSelectProps,
  renderSelectPopupScrollbar,
  selectPopupClassNames,
} from "../../Common/UIComponents/SelectPopupScrollbar";

import { ReactComponent as ChevronDown } from "../../../assets/images/common/ChevronDown.svg";
import "./SortBySelect.css";

export default function SortBySelect({
  options,
  selectedOptionIdx,
  onSelect,
  disabled,
}) {
  const selectOptions = options.map((item) => ({ value: item, label: item }));
  return (
    <Select
      variant="borderless"
      placeholder="Sort By"
      value={options[selectedOptionIdx]}
      options={selectOptions}
      onSelect={onSelect}
      {...getSearchableSelectProps()} // eslint-disable-line react/jsx-props-no-spreading
      suffixIcon={<ChevronDown className="SortBySelect__Chevron" />}
      className="SortBySelect"
      classNames={selectPopupClassNames("SortBySelect__Dropdown")}
      virtual={false}
      listHeight={256}
      popupRender={(menu) => renderSelectPopupScrollbar(menu, {
        optionCount: (options || []).length,
      })}
      disabled={disabled}
    />
  );
}
